module.exports = __webpack_public_path__ + "img/viber.b8e111f.png";